// src/menu-items/users.jsx
const Users = {
  id: "group-users",
  title: "Users",
  type: "group",
  children: [
    {
      id: "users-list",
      title: "User List",
      type: "item",
      url: "/users",
      icon: "ph ph-users",
    },
  ],
};

export default Users;
